import React from "react";
import useStyles from "../../../../components/common/model/styles";
import Popup from "../../../../components/common/model/Popup";
import { Alert, DialogContent, DialogContentText } from "@mui/material";
import closeIcon from "../../../../assets/closeModel.png";
import CustomButton from "../../../../components/common/button/CustomButton";

interface ActivationPopupProps {
  title?: string;
  open: boolean;
  onHide?: () => void;
  clientDetails?: any;
  setFormData?: any;
  formData?: any;
  alertModalShow: boolean;
  setAlertModelShow: (show: boolean) => void;
  setShowSuccessMessage?: (message: string) => void;
  resetAllValidator?: any;
  setIsClickReset?: any;
}
const ResetFormAlert: React.FC<ActivationPopupProps> = ({
  onHide,
  alertModalShow,
  setAlertModelShow,
  setIsClickReset
}) => {


  const classes = useStyles();
  const submitHandler = () => {
    setIsClickReset(true);
  };
  const closeModel = () => {
    setAlertModelShow(false);
  };

  return (
    <Popup
      open={alertModalShow}
      title={"Alert"}
      onHide={closeModel}
      fullWidth={true}
      maxWidth={"xs"}
      aria-describedby="alert-dialog-slide-description"
      header={
        <>
          <img
            onClick={closeModel}
            src={closeIcon}
            className={classes.closeicons}
            alt="close"
          />
        </>
      }
      footer={
        <>
          <CustomButton variant="outlined" title="No" onClick={closeModel} />
          <CustomButton title="Yes" onClick={submitHandler} />
        </>
      }
    >
      <DialogContent sx={{ padding: "0px" }}>
        <DialogContentText>
          <Alert
            sx={{ bgcolor: "#eeecef", fontSize: "16px" }}
            severity="warning"
          >
            Are you sure, you want to delete the data you have just entered?
          </Alert>
        </DialogContentText>
      </DialogContent>
    </Popup>
  );
};

export default ResetFormAlert;
